import React from 'react';
import styles from './style.js';
import { withStyles } from '@material-ui/core/styles';
import {Info1, Info2, Info3, Info4, Info5, Info6, Info7, Info8, Info9, Info10, Info11} from './Main/Static';
import ApiInfo from './Main/Dynamic/ApiInfo';

// const RendererContainer = connect(null, null);

// const ReduxWrapperComponent = (props) => <div>{RendererContainer(props.component)}</div>;

// HOC declaration
const ReduxWrapperComponent = (WrappedComponent) => {
  class HOC extends React.Component {
    render() {
      return (
        <WrappedComponent
          {...this.props}
        />
      );
    }
  }

  return HOC;
};

const Info = props => {
  return (
    <div>
      {{
        Info1: <Info1 {...props} />,
        Info2: <Info2 {...props} />,
        Info3: <Info3 {...props} />,
        Info4: <Info4 {...props} />,
        Info5: <Info5 {...props} />,
        Info6: <Info6 {...props} />,
        Info7: <Info7 {...props} />,
        Info8: <Info8 {...props} />,
        Info9: <Info9 {...props} />,
        Info10: <Info10 {...props} />,
        Info11: <Info11 {...props} />,
        ApiInfo: <ApiInfo {...props}/>
      }[props.infoContent.component]}
    </div>
  );
};

// (
//   <Info1 {...props}/>
// );

const WrappedComponent = ReduxWrapperComponent(Info);

export default withStyles(styles)(WrappedComponent);

